<template>
  <fieldset :class="{ 'transport-list w-100 mt-5 mb-2': true }">
    <legend>Transport</legend>

    <d-row class="mt-2 mb-1 ml-0 mr-0">
      <d-col cols="4">
        Departure Transport:
        <a :href="baseUrl + '/dashboard/airports/' + departureAirportId" target="_blank" class="text-primary">
          {{ departureAirport }}
        </a>
      </d-col>

      <d-col cols="6">
        <d-checkbox
          inline
          v-model="departure_transport_not_required"
          toggle
          toggle-small>
          not required
        </d-checkbox>
      </d-col>
    </d-row>

    <d-textarea
      v-if="!departure_transport_not_required"
      v-model="departure_transport_desc"
      :value.prop="departure_transport_desc"
      :rows="3" />

    <d-row class="mt-3 mb-1 ml-0 mr-0">
      <d-col cols="4">
        Arrival Transport:
        <a :href="baseUrl + '/dashboard/airports/' + arrivalAirportId" target="_blank" class="text-primary">
          {{ arrivalAirport }}
        </a>
      </d-col>

      <d-col cols="6">
        <d-checkbox
          inline
          v-model="arrival_transport_not_required"
          toggle
          toggle-small>
          not required
        </d-checkbox>
      </d-col>
    </d-row>

    <d-textarea
      v-if="!arrival_transport_not_required"
      v-model="arrival_transport_desc"
      :value.prop="arrival_transport_desc"
      :rows="3" />
  </fieldset>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Transport',
  computed: {
    baseUrl () {
      return window.location.protocol + '//' + window.location.host;
    }
  },
  props: [
    'departureAirport',
    'departureAirportId',
    'arrivalAirport',
    'arrivalAirportId',
    'referenceId',
    'departureTransportNotRequired',
    'arrivalTransportNotRequired',
    'type'
  ],
  watch: {
    departure_transport_not_required (newValue) {
      let field = 'crew_departure_transport';

      if (this.type === 'passenger') {
        field = 'passengers_departure_transport';
      }

      this.$bus.$emit('flight-form-not-required-update', field, newValue);
    },
    arrival_transport_not_required (newValue) {
      let field = 'crew_arrival_transport';

      if (this.type === 'passenger') {
        field = 'passengers_arrival_transport';
      }

      this.$bus.$emit('flight-form-not-required-update', field, newValue);
    },
    arrival_transport_desc (newValue) {
      let field = 'crew_arrival_transport';

      if (this.type === 'passenger') {
        field = 'passengers_arrival_transport';
      }

      this.$bus.$emit('flight-form-transport-update', field, newValue);
    },
    departure_transport_desc (newValue) {
      let field = 'crew_departure_transport';

      if (this.type === 'passenger') {
        field = 'passengers_departure_transport';
      }

      this.$bus.$emit('flight-form-transport-update', field, newValue);
    }
  },
  data () {
    return {
      arrival_transport_desc: '',
      departure_transport_desc: '',
      departure_transport_not_required: false,
      arrival_transport_not_required: false
    };
  },
  mounted () {
    this.departure_transport_not_required = !!this.departureTransportNotRequired;
    this.arrival_transport_not_required = !!this.arrivalTransportNotRequired;
    this.$bus.$on('pax-list-passengers-arrival-transport', this.updatePaxArrivalTransport);
    this.$bus.$on('pax-list-passengers-departure-transport', this.updatePaxDepartureTransport);
    this.$bus.$on('pax-list-crew-arrival-transport', this.updateCrewArrivalTransport);
    this.$bus.$on('pax-list-crew-departure-transport', this.updateCrewDepartureTransport);
  },
  methods: {
    updatePaxArrivalTransport (newValue) {
      if (this.type === 'passenger') {
        Vue.set(this, 'arrival_transport_desc', newValue);
      }
    },
    updatePaxDepartureTransport (newValue) {
      if (this.type === 'passenger') {
        Vue.set(this, 'departure_transport_desc', newValue);
      }
    },
    updateCrewArrivalTransport (newValue) {
      if (this.type === 'crew') {
        Vue.set(this, 'arrival_transport_desc', newValue);
      }
    },
    updateCrewDepartureTransport (newValue) {
      if (this.type === 'crew') {
        Vue.set(this, 'departure_transport_desc', newValue);
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('pax-list-passengers-arrival-transport', this.updatePaxArrivalTransport);
    this.$bus.$off('pax-list-passengers-departure-transport', this.updatePaxDepartureTransport);
    this.$bus.$off('pax-list-crew-arrival-transport', this.updateCrewArrivalTransport);
    this.$bus.$off('pax-list-crew-departure-transport', this.updateCrewDepartureTransport);
  }
}
</script>

<style lang="scss" scoped>
.transport-list {
  &.is-loading {
    fieldset {
      min-height: 120px;
    }

    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }

  .is-confirming {
    opacity: .33;
    pointer-events: none;
  }
}
</style>
